// TODO: Finish working on the header and see what code needs to be uncommented
import React, { useCallback, useMemo } from "react";
import { Cookies } from "react-cookie";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
// import { GlobalHeader as GlobalHeaderBase } from "@ubnt/store.core/lib/components/Header/Header";
import { MicrositeHeader } from "@ubnt/store.core/lib/components/MicrositeHeader";

import { COOKIE_MICROSITE_LANGUAGE } from "../../context/SiteSettingsContext/context";

import { useSiteSettings } from "../../context/SiteSettingsContext/context";
// import { useAuth } from "../../context/AuthContext";

import { handleOneTrust } from "util/oneTrust";

import {
  getPageBasePaths,
  saveCookie,
} from "context/SiteSettingsContext/utils";
import { LocalStorageKey } from "context/SiteSettingsContext";
import { HeaderWrap } from "./Header.styles";
import { useAuth } from "context/AuthContext";

// import { AccountMenu } from "@ubnt/store.core/lib/components/Header/AccountMenu";

/**
 * Pathnames excluding root "/" path
 * For that case change the default below
 */
const LIGHT_MOTIF_PAGE_PATHNAMES = [
  "/download",
  "/how-it-works",
  "/whats-new",
  "/site-support",
  "/cloud-gateways/resource-calculator",
  "/partner-hub",
];

/**
 * Pathnames where Microsite specific sub menu should be shown
 */
// const MICROSITE_SUB_MENU_PATHNAMES = ["/how-it-works", "/introduction"];

export const GlobalHeader = function GlobalHeader() {
  const location = useLocation();
  const history = useHistory();

  const [path, regionPath, regionLanguagePath] = getPageBasePaths("/");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const homepageRouteMatcher = {
    path: useRouteMatch(path),
    regionPath: useRouteMatch(regionPath),
    regionLanguagePath: useRouteMatch(regionLanguagePath),
  };

  const { onLinkClick } = useSiteSettings();
  const {
    user,
    loading: loadingAuth,
    handleLogin,
    handleLogout,
    handleRegister,
    handleManageAccount,
  } = useAuth();

  /** @type {import("@ubnt/store.core/lib/components/Header/Header.types").HeaderAccount} */
  const account = useMemo(() => {
    return {
      loading: loadingAuth,
      customer: user,
      handleLogin,
      handleLogout,
      handleRegister,
      handleManageAccount,
    };
  }, [
    handleLogin,
    handleLogout,
    handleManageAccount,
    handleRegister,
    loadingAuth,
    user,
  ]);

  // #############################################################################
  // Motif
  // #############################################################################
  const motif = useMemo(() => {
    const isHomepage = Object.values(homepageRouteMatcher ?? {}).some(
      (value) => value?.isExact,
    );

    const isLightThemePage = LIGHT_MOTIF_PAGE_PATHNAMES.some((pathname) =>
      location.pathname.includes(pathname),
    );

    if (isHomepage || isLightThemePage) {
      return "light";
    }

    return "dark";
  }, [location.pathname, homepageRouteMatcher]);

  // #############################################################################
  // Search
  // #############################################################################
  // const onSearchResultsAction = useCallback(
  //   (searchTerm) => {
  //     window.location.href = routes.search({ searchTerm });
  //   },
  //   [routes],
  // );

  // #############################################################################
  // Cart
  // #############################################################################
  // const onCartClick = useCallback(() => {
  //   window.location.href = routes.homepage();
  // }, [routes]);

  // #############################################################################
  // Custom menu item action
  // #############################################################################
  const onMenuItemLinkClick = useCallback(
    (e, url) => {
      onLinkClick(e, url);
    },
    [onLinkClick],
  );

  const handleCookie = useCallback((language) => {
    const cookies = new Cookies();
    const languageCookie = cookies.get(COOKIE_MICROSITE_LANGUAGE);

    if (languageCookie) {
      cookies.remove(COOKIE_MICROSITE_LANGUAGE);
    }

    try {
      saveCookie(COOKIE_MICROSITE_LANGUAGE, language.toUpperCase());
      localStorage.removeItem(LocalStorageKey.LanguageReferer);
    } catch (e) {
      console.log("saving microsite cookie error: ", e);
    }
  }, []);

  const onLanguageChange = (e, pathname, language) => {
    e.preventDefault();
    handleCookie(language);
    history.push(pathname);
    handleOneTrust(language);
  };

  // #############################################################################
  // Microsite Sub Menu (for "/introduction", "/how-it-works")
  // #############################################################################
  // const showMicrositeSubMenu = useMemo(() => {
  //   return MICROSITE_SUB_MENU_PATHNAMES.some((path) =>
  //     location.pathname.endsWith(path),
  //   );
  // }, [location.pathname]);

  return (
    <HeaderWrap>
      <MicrositeHeader
        onMenuItemClick={onMenuItemLinkClick}
        onLanguageChange={onLanguageChange}
        motif={motif}
        account={account}
      />
    </HeaderWrap>
  );
};
